import script from "./deleteAccount.vue?vue&type=script&lang=ts&setup=true"
export * from "./deleteAccount.vue?vue&type=script&lang=ts&setup=true"

import "./deleteAccount.vue?vue&type=style&index=0&id=5da6d35f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5da6d35f"]])

export default __exports__